export default "__VITE_ASSET__BOTOVGqw__"